/* SupplyMate artifact port: product page order box (.pm). Logic ported from product() in the
   "SupplyMate Site Preview" artifact, wired to real Shopify variants and the SupplyMate rules:
   Ready Stock (from 1 pc, ladder tiles), Low MOQ (Sample 1 pc / Bulk from custom.moq), Made to Order (quote). */
(() => {
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const dataEl = $("#sm-product-data");
  if (!dataEl) return;
  const D = JSON.parse(dataEl.textContent);
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
  const inr = (paise) => "₹" + Math.round(paise / 100).toLocaleString("en-IN");
  const toast = (m) => (window.smToast ? window.smToast(m) : alert(m));

  /* ---------- garment drawing for colour swatches (from the artifact) ---------- */
  const SHAPE_PATHS = {
    tee: "M62 34 L86 24 Q100 38 114 24 L138 34 L170 62 L154 86 L140 76 L140 200 L60 200 L60 76 L46 86 L30 62 Z",
    polo: "M62 34 L86 24 L100 30 L114 24 L138 34 L170 62 L154 86 L140 76 L140 200 L60 200 L60 76 L46 86 L30 62 Z",
    shirt: "M64 32 L88 22 L100 36 L112 22 L136 32 L156 72 L166 184 L148 186 L140 96 L140 202 L60 202 L60 96 L52 186 L34 184 L44 72 Z",
    hoodie: "M64 40 L82 30 Q100 6 118 30 L136 40 L156 76 L166 186 L148 188 L140 100 L140 202 L60 202 L60 100 L52 188 L34 186 L44 76 Z",
    jacket: "M64 32 L88 22 L100 30 L112 22 L136 32 L156 72 L166 186 L148 188 L140 96 L140 200 L60 200 L60 96 L52 188 L34 186 L44 72 Z",
    coat: "M66 30 L88 20 L100 44 L112 20 L134 30 L156 70 L164 188 L146 190 L140 100 L144 214 L56 214 L60 100 L54 190 L36 188 L44 70 Z",
    scrub: "M62 34 L86 24 L100 52 L114 24 L138 34 L168 62 L152 84 L140 76 L140 200 L60 200 L60 76 L48 84 L32 62 Z",
    kurti: "M66 30 L88 22 L100 42 L112 22 L134 30 L158 68 L150 132 L140 120 L148 214 L52 214 L60 120 L50 132 L42 68 Z",
    vest: "M72 24 L90 20 Q100 66 110 20 L128 24 L150 62 L148 196 L52 196 L50 62 Z",
    apron: "M80 20 L120 20 L122 70 L158 80 L156 204 L44 204 L42 80 L78 70 Z",
    pant: "M58 22 L142 22 L152 206 L114 206 L100 84 L86 206 L48 206 Z",
    shorts: "M56 40 L144 40 L156 150 L112 150 L100 96 L88 150 L44 150 Z",
    skirt: "M66 36 L134 36 L162 170 L38 170 Z",
    coverall: "M66 22 L88 16 L100 28 L112 16 L134 22 L154 60 L162 140 L146 142 L140 92 L146 214 L108 214 L100 130 L92 214 L54 214 L60 92 L54 142 L38 140 L46 60 Z",
  };
  const shapeOf = (t) => {
    t = (t || "").toLowerCase();
    const m = [["polo", "polo"], ["t-shirt", "tee"], ["tee", "tee"], ["hood", "hoodie"], ["jacket", "jacket"], ["blazer", "coat"], ["coat", "coat"], ["scrub", "scrub"], ["kurti", "kurti"], ["tunic", "kurti"], ["vest", "vest"], ["waistcoat", "vest"], ["koti", "vest"], ["apron", "apron"], ["trouser", "pant"], ["pant", "pant"], ["short", "shorts"], ["skirt", "skirt"], ["coverall", "coverall"], ["dungaree", "coverall"]];
    const hit = m.find(([k]) => t.includes(k));
    return hit ? hit[1] : "shirt";
  };
  const COLOURS = { black: "#1B1B1B", navy: "#1F2A44", "navy blue": "#1F2A44", red: "#C62828", grey: "#8A8F96", gray: "#8A8F96", white: "#F7F7F5", maroon: "#7A1F2B", "royal blue": "#1F4FB8", orange: "#E8761E", purple: "#6A3FA0", pink: "#F2A7C3", yellow: "#F2C230", "sky blue": "#9EC3E6", "dark green": "#1E4D2B", lime: "#B5D334", green: "#2E8B3E", beige: "#D8C3A0", brown: "#6B4A2E", "parrot green": "#59B33C", khaki: "#B9A57A", cream: "#F1E9D2" };
  function light(hex) { const n = parseInt(hex.slice(1), 16); return ((n >> 16) * 299 + ((n >> 8) & 255) * 587 + (n & 255) * 114) / 1000 > 170; }
  function garment(c, sh) {
    const stroke = light(c) ? "rgba(11,22,38,.28)" : "rgba(255,255,255,.18)";
    const path = SHAPE_PATHS[sh] || SHAPE_PATHS.shirt;
    return `<svg viewBox="20 0 160 224" aria-hidden="true"><ellipse cx="100" cy="216" rx="58" ry="5" fill="rgba(11,22,38,.08)"/><path d="${path}" fill="${c}" stroke="${stroke}" stroke-width="1.5" stroke-linejoin="round"/><path d="${path}" fill="url(#shine)" opacity=".5"/></svg>`;
  }
  if (!document.getElementById("shine")) document.body.insertAdjacentHTML("afterbegin", `<svg width="0" height="0" style="position:absolute" aria-hidden="true"><defs><linearGradient id="shine" x1="0" x2="1" y1="0" y2="1"><stop offset="0" stop-color="#fff" stop-opacity=".35"/><stop offset=".5" stop-color="#fff" stop-opacity="0"/><stop offset="1" stop-color="#000" stop-opacity=".12"/></linearGradient></defs></svg>`);
  const sh = shapeOf(`${D.type} ${D.title}`);
  $$("#pm-colours [data-colour]").forEach((b) => { const hex = COLOURS[b.dataset.colour.toLowerCase()] || "#8A8F96"; $(".sw", b).innerHTML = garment(hex, sh); });

  /* ---------- data ---------- */
  const opt = (i) => (i >= 0 ? D.options[i] : null);
  const valuesOf = (i) => (i < 0 ? [] : [...new Set(D.variants.map((v) => v.o[i]))]);
  const fabrics = valuesOf(D.fabricIndex), types = valuesOf(D.typeIndex), colours = valuesOf(D.colourIndex), sizes = valuesOf(D.sizeIndex);
  const tierOf = (v) => String(v || "").split(" · ")[0].trim();
  const TIERS = D.tiers || {}; // from metaobjects fabric_tier: { "<Fabric value>": { blurb, img } }
  const SWATCH_DEFAULT = $(".ats-img-swatch img")?.getAttribute("src") || "";
  const isSampleVal = (t) => /sample/i.test(t || "");
  const st = {
    fab: fabrics[0] || null,
    type: types.find((t) => !isSampleVal(t)) || types[0] || null,
    colour: colours[0] || null,
    qty: 1, bySize: Object.fromEntries(sizes.map((s) => [s, 0])), brand: "dtf", slide: 0,
  };
  const matches = (v, fab, type, colour, size) =>
    (D.fabricIndex < 0 || v.o[D.fabricIndex] === fab) && (D.typeIndex < 0 || v.o[D.typeIndex] === type) &&
    (D.colourIndex < 0 || v.o[D.colourIndex] === colour) && (size == null || D.sizeIndex < 0 || v.o[D.sizeIndex] === size);
  function priceFor(fab, type = st.type, colour = st.colour) {
    const vs = D.variants.filter((v) => matches(v, fab, type, colour, null));
    return vs.length ? Math.min(...vs.map((v) => v.p)) : Math.min(...D.variants.map((v) => v.p));
  }
  // start on the cheapest fabric, like the artifact
  if (fabrics.length > 1) st.fab = fabrics.reduce((a, f) => (priceFor(f) < priceFor(a) ? f : a), fabrics[0]);
  const variantFor = (size) => D.variants.find((v) => matches(v, st.fab, st.type, st.colour, size));
  const sample = () => D.typeIndex >= 0 && isSampleVal(st.type);
  const ladder = () => {
    let L = Array.isArray(D.ladder) ? D.ladder.filter((t) => t && t.qty > 0) : [];
    if (D.av === "low" && !sample()) L = L.filter((t) => t.qty >= D.moq);
    if (!L.length) L = [{ qty: minQty(), off: 0 }];
    return L;
  };
  function minQty() {
    if (D.av === "low") return sample() ? 1 : D.moq;
    if (D.av === "ready") { const L = Array.isArray(D.ladder) && D.ladder.length ? D.ladder[0].qty : 1; return Math.max(1, L || 1); }
    return 1;
  }
  const tierIndex = (q, L) => L.reduce((a, t, i) => (q >= t.qty ? i : a), 0);
  const tierRange = (i, L) => { const lo = L[i].qty, hi = L[i + 1] ? L[i + 1].qty - 1 : null; return hi ? (lo === hi ? `${lo} pc${lo > 1 ? "s" : ""}` : `${lo}–${hi} pcs`) : `${lo}+ pcs`; };
  const sizeSum = () => Object.values(st.bySize).reduce((a, b) => a + b, 0);
  st.qty = minQty();

  /* ---------- render ---------- */
  const setTxt = (id, t) => { const e = document.getElementById(id); if (e) e.textContent = t; };
  function render() {
    const L = ladder();
    const mq = minQty();
    if (sample()) st.qty = 1;
    if (st.qty < mq) st.qty = mq;
    if (sizeSum() > st.qty && !sample()) st.qty = sizeSum();
    // colour
    setTxt("pm-colour-name", st.colour || "");
    $$("#pm-colours [data-colour]").forEach((b) => b.setAttribute("aria-pressed", b.dataset.colour === st.colour));
    // fabric
    setTxt("pm-fab-name", st.fab || "");
    $$("#pm-fabrics [data-fab]").forEach((b) => {
      b.setAttribute("aria-pressed", b.dataset.fab === st.fab);
    });
    ["ats-fab-name", "ats-tag-name", "ats-swatch-tag"].forEach((id) => st.fab && setTxt(id, st.fab));
    const tier = TIERS[tierOf(st.fab)] || {};
    if (tier.blurb) setTxt("ats-fab-cloth", tier.blurb);
    // the fabric tile at the end of the gallery (and the Fabric story picture) shows the selected tier's image
    const timg = tier.img || SWATCH_DEFAULT;
    $$(".ats-img-swatch img, #ats-swatch img, .ats-thumb[data-swatch] img").forEach((im) => { if (timg && im.getAttribute("src") !== timg) im.setAttribute("src", timg); });
    // order type
    setTxt("pm-type-name", st.type || "");
    $$("#pm-types [data-type]").forEach((b) => b.setAttribute("aria-pressed", b.dataset.type === st.type));
    // quantity
    const q = $("#pm-qty");
    if (q) { q.value = st.qty; q.min = mq; q.disabled = sample(); }
    if ($("#pm-minus")) $("#pm-minus").disabled = st.qty <= mq || sample();
    if ($("#pm-plus")) $("#pm-plus").disabled = sample();
    setTxt("pm-qty-badge", `${st.qty} pc${st.qty > 1 ? "s" : ""}`);
    // sizes
    const sum = sizeSum();
    sizes.forEach((s) => { const e = $(`[data-s="${CSS.escape(s)}"]`); if (e) e.textContent = st.bySize[s]; });
    $$("#pm-sizes [data-dec]").forEach((b) => { b.disabled = st.bySize[b.dataset.dec] === 0; });
    $$("#pm-sizes [data-inc]").forEach((b) => { b.disabled = sample() && sum >= 1; });
    setTxt("pm-size-count", `${sum}/${st.qty} selected`);
    const pr = $("#pm-progress"); if (pr) pr.style.width = `${Math.min(100, (sum / st.qty) * 100)}%`;
    const hint = $("#pm-size-hint");
    if (hint) { hint.textContent = sum < st.qty ? `Choose sizes for ${st.qty - sum} more` : "All sizes chosen ✓"; hint.classList.toggle("ok", sum >= st.qty); }
    // logo (ready stock: 1 pc ships plain)
    const plainOnly = D.av === "ready" && st.qty < 2;
    if (plainOnly && st.brand !== "none") { st.brand = "none"; st.forced = true; }
    if (!plainOnly && st.forced) { st.brand = "dtf"; st.forced = false; }
    $$("#pm-brand [data-brand]").forEach((b) => { b.setAttribute("aria-pressed", b.dataset.brand === st.brand); b.disabled = plainOnly && b.dataset.brand !== "none"; b.style.opacity = b.disabled ? ".45" : ""; });
    const bh = $("#pm-brand-hint"); if (bh) bh.hidden = !plainOnly;
    setTxt("pm-st-l1", [st.fab, st.colour, `${st.qty} pc${st.qty > 1 ? "s" : ""}`].filter(Boolean).join(" · "));
    if (D.av === "made") return;
    // price
    const base = priceFor(st.fab);
    const ti = tierIndex(st.qty, L), d = sample() ? 0 : L[ti].off;
    const unit = base * (1 - d / 100), total = unit * st.qty, was = base * st.qty;
    // Headline shows the price per piece (Sparsh, 2 Nov); the order total stays in the quantity box.
    setTxt("pm-now", `${inr(unit)} / pc`);
    setTxt("pm-was", d ? inr(base) : "");
    setTxt("pm-save", d ? `SAVE ${+d.toFixed(2)}%` : "BASE RATE");
    setTxt("pm-unit", inr(unit));
    setTxt("pm-total", `${inr(total)} total`);
    setTxt("pm-you-save", d && st.qty > 1 ? `You save ${inr(was - total)} on this order` : "");
    // fabric cards show the price per piece at the chosen quantity
    $$("#pm-fabrics [data-fab] em").forEach((em) => { const f = em.closest("[data-fab]").dataset.fab; em.textContent = `${inr(priceFor(f) * (1 - d / 100))}/pc${d ? ` at ${st.qty} pcs` : ""}`; });
    const tiles = $("#pm-tiles"), tl = $("#pm-tiles-label"), up = $("#pm-upsell");
    if (tiles) {
      tiles.hidden = sample(); if (tl) tl.hidden = sample();
      tiles.innerHTML = L.map((t, i) => `<button class="pm-tile" data-q="${t.qty}" aria-pressed="${i === ti}"><span class="r num">${tierRange(i, L)}</span><b class="num">${inr(base * (1 - t.off / 100))}</b><span class="o">${t.off ? `${+(+t.off).toFixed(2)}% less` : "Base"}</span></button>`).join("");
    }
    const next = L[ti + 1];
    if (up) {
      if (next && !sample()) {
        const need = next.qty - st.qty, nu = base * (1 - next.off / 100);
        up.innerHTML = `<span>Add <b>${need} more</b> piece${need > 1 ? "s" : ""} → pay <b class="num">${inr(nu)}/pc</b> and save <b class="num">${inr(unit - nu)}</b> on every piece.</span><button class="pm-make" data-make="${next.qty}">Make it ${next.qty}</button>`;
        up.hidden = false;
      } else up.hidden = true;
    }
    setTxt("pm-st-now", inr(total));
    setTxt("pm-st-was", d ? inr(was) : "");
    setTxt("pm-st-off", d ? `${+(+d).toFixed(2)}% OFF` : "");
    const so = $("#pm-st-off"); if (so) so.hidden = !d;
  }

  /* ---------- events ---------- */
  const setQty = (n) => { st.qty = Math.max(minQty(), Math.min(9999, n || 0)); if (sizeSum() > st.qty) st.qty = sizeSum(); render(); };
  $("#pm-colours")?.addEventListener("click", (e) => { const b = e.target.closest("[data-colour]"); if (b) { st.colour = b.dataset.colour; render(); } });
  $("#pm-fabrics")?.addEventListener("click", (e) => { const b = e.target.closest("[data-fab]"); if (b) { st.fab = b.dataset.fab; render(); } });
  $("#pm-types")?.addEventListener("click", (e) => {
    const b = e.target.closest("[data-type]"); if (!b) return;
    st.type = b.dataset.type;
    if (sample()) { st.bySize = Object.fromEntries(sizes.map((s) => [s, 0])); st.qty = 1; } else st.qty = Math.max(st.qty, minQty());
    render();
  });
  $("#pm-brand")?.addEventListener("click", (e) => { const b = e.target.closest("[data-brand]"); if (b && !b.disabled) { st.brand = b.dataset.brand; st.forced = false; render(); } });
  $("#pm-minus")?.addEventListener("click", () => setQty(st.qty - 1));
  $("#pm-plus")?.addEventListener("click", () => setQty(st.qty + 1));
  $("#pm-qty")?.addEventListener("change", (e) => setQty(parseInt(e.target.value, 10)));
  $("#pm-tiles")?.addEventListener("click", (e) => { const b = e.target.closest("[data-q]"); if (b) setQty(+b.dataset.q); });
  $("#pm-upsell")?.addEventListener("click", (e) => { const b = e.target.closest("[data-make]"); if (b) setQty(+b.dataset.make); });
  $("#pm-sizes")?.addEventListener("click", (e) => {
    const inc = e.target.closest("[data-inc]"), dec = e.target.closest("[data-dec]");
    if (inc && !inc.disabled) { st.bySize[inc.dataset.inc]++; if (sizeSum() > st.qty && !sample()) st.qty = sizeSum(); }
    if (dec && st.bySize[dec.dataset.dec] > 0) st.bySize[dec.dataset.dec]--;
    render();
  });
  // gallery
  $("#pm-thumbs")?.addEventListener("click", (e) => {
    const b = e.target.closest("[data-slide]"); if (!b) return;
    st.slide = +b.dataset.slide;
    const track = $("#ats-track"), img = track.querySelector(`[data-img="${st.slide}"]`);
    if (img) track.scrollTo({ left: img.offsetLeft - track.offsetLeft, behavior: "smooth" });
    $$("#pm-thumbs [data-slide]").forEach((t) => t.setAttribute("aria-pressed", t === b));
  });
  $("#ats-track")?.addEventListener("scroll", () => {
    const track = $("#ats-track"), w = track.querySelector("[data-img]")?.offsetWidth || 1;
    const i = Math.round(track.scrollLeft / (w + 10));
    if (i !== st.slide) { st.slide = i; $$("#pm-thumbs [data-slide]").forEach((t) => t.setAttribute("aria-pressed", +t.dataset.slide === i)); }
  }, { passive: true });
  $$(".ats-q").forEach((d) => d.addEventListener("toggle", () => { if (d.open) $$(".ats-q").forEach((o) => o !== d && (o.open = false)); }));
  $("#ats-pause")?.addEventListener("click", (e) => { const v = $("#ats-vid"); if (v.paused) { v.play(); e.currentTarget.textContent = "❚❚"; } else { v.pause(); e.currentTarget.textContent = "▶"; } });
  const chain = $("#ats-chain");
  chain?.addEventListener("scroll", () => {
    const cards = [...chain.children], i = Math.min(cards.length - 1, Math.round(chain.scrollLeft / ((cards[0]?.offsetWidth || 1) + 16)));
    $$("#ats-steps [data-step]").forEach((s) => s.classList.toggle("on", +s.dataset.step <= i));
  }, { passive: true });

  /* ---------- add to cart: one line per size, files uploaded once ---------- */
  const BRAND = { dtf: "Printed logo (free)", none: "No logo" };
  async function go(e) {
    if (D.av === "made") return; // quote link
    e.preventDefault();
    const missing = st.qty - sizeSum();
    if (sizes.length && missing > 0) { toast(`Choose sizes for ${missing} more piece${missing > 1 ? "s" : ""}`); $("#pm-sizes")?.scrollIntoView({ behavior: "smooth", block: "center" }); return; }
    const lines = sizes.length ? sizes.filter((s) => st.bySize[s]).map((s) => ({ v: variantFor(s), q: st.bySize[s], s })) : [{ v: variantFor(null), q: st.qty }];
    if (lines.some((l) => !l.v)) { toast("This combination is not available. Please pick another fabric or size."); return; }
    const props = { "Logo": BRAND[st.brand] };
    const txt = $("#pm-text")?.value.trim(); if (txt) props["Instructions"] = txt;
    const logo = $("#pm-logo")?.files[0], voice = $("#pm-voice")?.files[0];
    const btns = [$("#pm-atc"), $("#pm-st-btn")].filter(Boolean);
    btns.forEach((b) => (b.disabled = true));
    try {
      let rest = lines;
      if (logo || voice) {
        const fd = new FormData();
        fd.append("id", lines[0].v.id); fd.append("quantity", lines[0].q);
        Object.entries(props).forEach(([k, v]) => fd.append(`properties[${k}]`, v));
        if (logo) fd.append("properties[Logo file]", logo);
        if (voice) fd.append("properties[Voice note]", voice);
        const r = await fetch("/cart/add.js", { method: "POST", body: fd, headers: { Accept: "application/json" } });
        const j = await r.json();
        if (!r.ok) throw new Error(j.description || j.message || "Could not add to cart");
        const up = j.properties || {};
        if (up["Logo file"]) props["Logo file"] = up["Logo file"];
        if (up["Voice note"]) props["Voice note"] = up["Voice note"];
        rest = lines.slice(1);
      }
      if (rest.length) {
        const r = await fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: rest.map((l) => ({ id: l.v.id, quantity: l.q, properties: props })) }) });
        const j = await r.json();
        if (!r.ok) throw new Error(j.description || j.message || "Could not add to cart");
      }
      if (window.smOpenCart) window.smOpenCart(); else location.href = "/cart";
    } catch (err) { toast(err.message); }
    btns.forEach((b) => (b.disabled = false));
  }
  // Low MOQ: buy 1 sample piece through the hidden "sample-piece" product (variant priced at custom.sample_price)
  $("#pm-sample-btn")?.addEventListener("click", async (e) => {
    const box = $("#pm-sample"), vid = box?.dataset.sampleVariant;
    if (!vid) return;
    const size = sizes.find((s) => st.bySize[s] > 0);
    if (sizes.length && !size) { toast("Tap + on one size above for your sample"); $("#pm-sizes")?.scrollIntoView({ behavior: "smooth", block: "center" }); return; }
    const props = { Design: D.title };
    if (box.dataset.designId) props["Design ID"] = box.dataset.designId;
    if (st.fab) props.Fabric = st.fab;
    if (st.colour) props.Colour = st.colour;
    if (size) props.Size = size;
    e.currentTarget.disabled = true;
    try {
      const r = await fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: [{ id: +vid, quantity: 1, properties: props }] }) });
      const j = await r.json();
      if (!r.ok) throw new Error(j.description || j.message || "Could not add the sample");
      if (window.smOpenCart) window.smOpenCart(); else location.href = "/cart";
    } catch (err) { toast(err.message); }
    e.currentTarget.disabled = false;
  });
  $("#pm-atc")?.addEventListener("click", go);
  $("#pm-st-btn")?.addEventListener("click", go);
  // quote links carry the chosen quantity for made-to-order styles
  if (D.av === "made") {
    const upd = () => $$("#pm-atc, #pm-st-btn").forEach((a) => { const u = new URL(a.href, location.origin); u.searchParams.set("product", D.handle); u.searchParams.set("qty", st.qty); const s = sizes.filter((x) => st.bySize[x]).map((x) => `${x}x${st.bySize[x]}`).join(" "); if (s) u.searchParams.set("sizes", s); else u.searchParams.delete("sizes"); a.href = u.pathname + u.search; });
    document.addEventListener("click", () => setTimeout(upd, 0)); upd();
  }
  render();
})();
